// extracted by mini-css-extract-plugin
module.exports = {"backgroundLayerPopUp":"Modal_backgroundLayerPopUp__1blZV","modal":"Modal_modal__3Tkov","closeModal":"Modal_closeModal__3qsAc"};